<template>
  <div class="card">
    <div class="card-body">
      <h4>{{ "discounts" | t | titlecase }}</h4>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th>Value</th>
          <th>Comment</th>
          <th>Discount cause</th>
          <th>Discount source</th>
          <th class="text-right">Used at</th>
          <th class="text-right">Status</th>
          <th></th>
        </tr>
      </thead>
      <tbody></tbody>
      <tr v-for="(discount, idx) in discounts" :key="discount.id || idx">
        <td>
          <span>{{ discount.value }}</span
          ><span v-if="discount.discount_type == 'fixed'">{{
            customer.currency
          }}</span
          ><span v-if="discount.discount_type == 'percentage'">%</span>
        </td>
        <td>{{ discount.comment }}</td>
        <td>{{ discount.discount_cause | t }}</td>
        <td>{{ discount.discount_source | t }}</td>
        <td class="text-right">
          <span v-if="discount.status == 'used'">{{
            discount.updated_at | datetime
          }}</span>
        </td>
        <td class="text-right">{{ discount.status }}</td>
        <td class="text-right text-danger">
          <span
            v-if="discount.status == 'unused'"
            role="button"
            @click="deleteDiscount(discount, idx)"
            >delete</span
          >
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    customer: Object,
    discounts: Array,
  },
  methods: {
    deleteDiscount(discount, idx) {
      this.$emit("deleteDiscount", discount, idx);
    },
  },
};
</script>